// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RelayEnv = require("../../../RelayEnv.bs.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let EmailRegistrationStatusQuery_graphql = require("../../../__generated__/EmailRegistrationStatusQuery_graphql.bs.js");

let convertVariables = EmailRegistrationStatusQuery_graphql.Internal.convertVariables;

let convertResponse = EmailRegistrationStatusQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = EmailRegistrationStatusQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, EmailRegistrationStatusQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, EmailRegistrationStatusQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(EmailRegistrationStatusQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(EmailRegistrationStatusQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(EmailRegistrationStatusQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(EmailRegistrationStatusQuery_graphql.node, convertVariables);

let Query_emailRegistrationStatus_decode = EmailRegistrationStatusQuery_graphql.Utils.emailRegistrationStatus_decode;

let Query_emailRegistrationStatus_fromString = EmailRegistrationStatusQuery_graphql.Utils.emailRegistrationStatus_fromString;

let Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function queryFn(emailAddress) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
    emailAddress: emailAddress
  }, undefined, undefined)), v => {
    if (v.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: {
          NAME: "REJECTED",
          VAL: v._0
        }
      };
    }
    let match = v._0.emailRegistrationStatus;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "EMPTY_RESPONSE"
      };
    }
    let status = match.status;
    if (status === "AVAILABLE" || status === "REGISTERED") {
      return {
        TAG: "Ok",
        _0: status
      };
    } else {
      return {
        TAG: "Error",
        _0: "UNSELECTED_ENUM"
      };
    }
  });
}

exports.Query = Query;
exports.queryFn = queryFn;
/* use Not a pure module */
